import React from "react"

import globalStyles from "../../../../App.module.scss";
import backup from './images/backup.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function BackupRotation() {

    let data = `import argparse
import shutil
import time
from pathlib import Path


def create_backup(source, backup_dir):
    backup_dir = Path(backup_dir)
    backup_dir.mkdir(parents=True, exist_ok=True)
    timestamp = time.strftime("%Y%m%d-%H%M%S")
    archive_base = backup_dir / f"{Path(source).name}-{timestamp}"
    return Path(shutil.make_archive(str(archive_base), "zip", source))


def prune_old_backups(backup_dir, keep):
    backups = sorted(Path(backup_dir).glob("*.zip"), key=lambda p: p.stat().st_mtime, reverse=True)
    for old_backup in backups[keep:]:
        old_backup.unlink()
        print(f"Removed old backup: {old_backup.name}")


def main():
    parser = argparse.ArgumentParser(description="Zip a folder and keep only the last N backups")
    parser.add_argument("source", help="folder to back up")
    parser.add_argument("backup_dir", help="where to store backup archives")
    parser.add_argument("--keep", type=int, default=5)
    args = parser.parse_args()

    archive_path = create_backup(args.source, args.backup_dir)
    print(f"Created backup: {archive_path.name}")

    prune_old_backups(args.backup_dir, args.keep)


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>Backup with rotation</h1>
            <p>Zips a folder into a timestamped archive, then prunes old archives so only the most recent
                <code>--keep</code> backups (5 by default) are kept. Safe to run on a schedule — each run adds one
                backup and removes at most one old one, so storage stays bounded.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={backup} alt={""}/>
            </div>
        </div>
    )
}
